// src/locales/si/report.js
export const report = {
  // Page Title
  salesReport: 'විකුණුම් වාර්තාව',
  salesReportSubtitle: 'අන්තර්ක්‍රියාකාරී චාට් සහ විස්තරාත්මක වගු මගින් විකුණුම් දත්ත විශ්ලේෂණය කරන්න',

  // Filter Section
  filters: 'පෙරහන්',
  applyFilters: 'පෙරහන් යොදන්න',
  resetFilters: 'පෙරහන් නැවත සකසන්න',
  applying: 'යොදමින්...',

  // Date Range
  dateRange: 'දිනයේ පරාසය',
  dateFrom: 'ආරම්භක දිනය',
  dateTo: 'අවසාන දිනය',
  selectDateRange: 'දිනයේ පරාසය තෝරන්න',
  today: 'අද',
  thisWeek: 'මේ සතිය',
  thisMonth: 'මේ මාසය',
  lastMonth: 'පසුගිය මාසය',
  thisYear: 'මේ වසර',
  customRange: 'අභිරුචි පරාසය',

  // Shared achieved/target labels (used by chart datasets)
  achieved: 'ජයග්‍රහණය',
  target: 'ඉලක්කය',

  // Grouping
  grouping: 'කණ්ඩායම් කිරීම',
  groupByDate: 'දිනය අනුව කණ්ඩායම් කරන්න',
  groupByWeek: 'සතිය අනුව කණ්ඩායම් කරන්න',
  groupByMonth: 'මාසය අනුව කණ්ඩායම් කරන්න',

  // Filter By Date Type
  filterByDateType: 'දිනයේ වර්ගය අනුව පෙරහන් කරන්න',
  createdDate: 'නිර්මාණය කළ දිනය',
  dispatchedDate: 'බෙදාහැරූ දිනය',

  // Shop Filter
  shop: 'සාප්පුව',
  allShops: 'සියලු සාප්පු',
  selectShops: 'සාප්පු තෝරන්න',
  selectAll: 'සියල්ල තෝරන්න',
  deselectAll: 'සියල්ල ඉවත් කරන්න',
  selectAtLeastOneShop: 'කරුණාකර අවම වශයෙන් එක් සාප්පුවක් තෝරන්න',
  paymentType: 'ගෙවීම් වර්ගය',
  selectPaymentTypes: 'ගෙවීම් වර්ග තෝරන්න',
  salesRep: 'විකුණුම් නියෝජිත',
  allSalesReps: 'සියලුම විකුණුම් නියෝජිතයන්',
  groupBySalesRep: 'විකුණුම් නියෝජිත අනුව බෙදීම පෙන්වන්න',
  salesRepBreakdown: 'නියෝජිත අනුව විකුණුම්',
  unassignedSalesRep: 'පවරා නැත',
  selectAtLeastOnePaymentType: 'කරුණාකර අවම වශයෙන් එක් ගෙවීම් වර්ගයක් තෝරන්න',
  excludeDeliveryCharge: 'විකුණුම් වටිනාකමෙන් බෙදාහැරීමේ ගාස්තුව ඉවත් කරන්න',
  deliveryChargeSettingSaved: 'විකුණුම් වටිනාකම් සැකසුම යාවත්කාලීන විය',
  deliveryChargeSettingFailed: 'විකුණුම් වටිනාකම් සැකසුම යාවත්කාලීන කිරීම අසාර්ථක විය',
  selectAtLeastOneChannel: 'කරුණාකර අවම වශයෙන් එක් නාලිකාවක් තෝරන්න',
  channel: 'නාලිකාව',
  channelOnline: 'ඔන්ලයින්',
  channelOffline: 'ඕෆ්ලයින්',
  channelPos: 'POS',
  statusAppliesToOnline: 'තත්ත්ව පෙරහන ඔන්ලයින් ඇණවුම් සඳහා පමණක් අදාළ වේ',
  selectShop: 'සාප්පුව තෝරන්න',

  // Status Filter
  orderStatus: 'ඇණවුමේ තත්ත්වය',
  allStatuses: 'සියලු බෙදාහැරූ තත්ත්වයන්',
  selectStatuses: 'තත්ත්වයන් තෝරන්න',

  // View Type
  viewType: 'දර්ශන වර්ගය',
  timePeriodView: 'කාල පරාස දර්ශනය',
  productView: 'නිෂ්පාදන දර්ශනය',

  // Summary Cards
  totalOrders: 'එකතුව ඇණවුම්',
  totalRevenue: 'එකතුව ආදායම',
  totalQuantity: 'එකතුව ප්‍රමාණය',
  orders: 'ඇණවුම්',
  items: 'අයිතම',

  // Chart Section
  chartVisualization: 'ප්‍රස්තාර දැක්ම',
  revenue: 'ආදායම',
  quantity: 'ප්‍රමාණය',
  orderCount: 'ඇණවුම් ගණන',
  noDataAvailable: 'තෝරාගත් පෙරහන් සඳහා දත්ත නොමැත',

  // Table Section
  dataTable: 'දත්ත වගුව',
  period: 'කාල පරාසය',
  productName: 'නිෂ්පාදන නාමය',
  productType: 'නිෂ්පාදන වර්ගය',
  quantitySold: 'විකුණුම් ප්‍රමාණය',
  totalValue: 'මුළු අගය',
  actions: 'ක්‍රියාමාර්ග',
  viewDetails: 'විස්තර බලන්න',

  // Product Types
  simple: 'සරල',
  variable: 'විචල්‍ය',

  // Detailed View
  orderNumber: 'ඇණවුම් අංකය',
  orderDate: 'ඇණවුම් දිනය',
  shopName: 'සාප්පුව',
  status: 'තත්ත්වය',
  quantity: 'ප්‍රමාණය',
  value: 'අගය',

  // Order Items
  variationDetails: 'වෙරළ විස්තර',
  lineTotal: 'පේළි එකතුව',

  // Variations
  variationSku: 'SKU',
  attributeCombination: 'ගුණාංග එකතු කිරීම',

  // Pagination
  showing: 'පෙන්වමින්',
  to: 'දක්වා',
  of: 'නම්',
  results: 'ප්‍රතිඵල',
  page: 'පිටුව',
  previous: 'පෙර',
  next: 'ඊළඟ',

  // Export
  export: 'නිර්යාත කරන්න',
  exportToExcel: 'Excel වෙත නිර්යාත කරන්න',
  exportToCsv: 'CSV වෙත නිර්යාත කරන්න',
  exportChart: 'චාට් නිර්යාත කරන්න',
  exporting: 'නිර්යාත කරමින්...',
  exportSuccess: 'නිර්යාතය සාර්ථකව අවසන් විය',
  exportFailed: 'නිර්යාතය අසාර්ථක විය',

  // Empty States
  noOrdersFound: 'ඇණවුම් නොමැත',
  noOrdersMessage: 'තෝරාගත් පෙරහන් වලට ගැලපෙන ඇණවුම් නොමැත. කරුණාකර පෙරහන් වෙනස් කරන්න.',

  // Validation
  dateFromRequired: 'ආරම්භක දිනය අවශ්‍යයි',
  dateToRequired: 'අවසාන දිනය අවශ්‍යයි',
  dateRangeInvalid: 'අවසාන දිනය ආරම්භක දිනයට පසු විය යුතුය',
  groupByDateRequired: 'කණ්ඩායම් කිරීම අවශ්‍යයි',
  filterByDateRequired: 'දිනය අනුව පෙරහන් කිරීම අවශ්‍යයි',

  // Loading
  loadingFilters: 'පෙරහන් පූරණය වෙමින්...',
  loadingData: 'දත්ත පූරණය වෙමින්...',

  // Errors
  failedToLoadFilters: 'පෙරහන් විකල්ප පූරණය අසාර්ථක විය',
  failedToLoadData: 'විකුණුම් දත්ත පූරණය අසාර්ථක විය',
  tryAgain: 'නැවත උත්සාහ කරන්න',

  // ── Profit & Loss Report ────────────────────────────────────────────────────
  pnlReport: {
    title: 'ලාභ සහ අලාභ වාර්තාව',
    subtitle: 'ඔබේ ව්‍යාපාරයේ සවිස්තරාත්මක ආදායම් වාර්තාව',
    groupByLabel: 'දර්ශන ක්‍රමය',
    groupByNone: 'සාරාංශය',
    groupByMonth: 'මාසික',
    groupByQuarter: 'කාර්තුව',
    thisQuarter: 'මේ කාර්තුව',
    lastQuarter: 'පසුගිය කාර්තුව',
    generateReport: 'වාර්තාව ජනනය කරන්න',
    generating: 'ජනනය කරමින්...',
    exportExcel: 'Excel වෙත අපනයනය කරන්න',
    exporting: 'අපනයනය කරමින්...',
    revenue: 'ආදායම',
    ecomSales: 'ඊකොම් විකිණීම්',
    realizedSales: 'සාක්ෂාත් කළ විකිණීම්',
    unrealizedSales: 'සාක්ෂාත් නොකළ විකිණීම්',
    salesReturns: 'අඩු: විකිණීම් ආපසු',
    posSales: 'POS විකිණීම්',
    lessPosReturns: 'අඩු: POS ආපසු',
    netRevenue: 'නිවුල් ආදායම',
    cogs: 'විකුණු භාණ්ඩවල වියදම',
    openingStock: 'ආරම්භක තොගය',
    addPurchases: 'එකතු: මිලදී ගැනීම්',
    lessClosingStock: 'අඩු: අවසාන තොගය',
    cogsTotal: 'විකුණු භාණ්ඩවල වියදම',
    posProductCost: 'POS නිෂ්පාදන පිරිවැය',
    grossProfit: 'දළ ලාභය',
    operatingExpenses: 'මෙහෙයුම් වියදම්',
    courierCharges: 'කුරියර් ගාස්තු',
    posFees: 'POS ගෙවීම් ගාස්තු',
    totalExpenses: 'මුළු මෙහෙයුම් වියදම්',
    netProfit: 'නිවුල් ලාභය',
    netLoss: 'නිවුල් අලාභය',
    total: 'මුළු',
    noData: 'තෝරාගත් කාලය සඳහා දත්ත නොමැත',
    selectFiltersPrompt: 'ඔබේ පෙරහන් තෝරා "වාර්තාව ජනනය කරන්න" ක්ලික් කරන්න',
    failedToLoad: 'ලාභ සහ අලාභ දත්ත පූරණය අසාර්ථක විය',
    failedToLoadFilters: 'පෙරහන් විකල්ප පූරණය අසාර්ථක විය',
  },

  courierPerformance: {
    title: 'කුරියර් කාර්ය සාධන වාර්තාව',
    subtitle: 'කුරියර් බෙදාහැරීමේ කාර්ය සාධනය සවිස්තරාත්මක දත්ත සමග විශ්ලේෂණය කරන්න',

    // Group By Options
    groupBy: 'කණ්ඩායම් අනුව',
    groupByRequired: 'කණ්ඩායම් කිරීම අවශ්‍යයි',
    byDate: 'දිනය අනුව',
    byWeek: 'සතිය අනුව',
    byMonth: 'මාසය අනුව',
    byShippingZone: 'නැව්ගත ප්‍රදේශ අනුව',
    byDistrict: 'දිස්ත්‍රික්ක අනුව',
    byProvince: 'පළාත අනුව',

    // Date Presets
    today: 'අද',
    thisWeek: 'මේ සතිය',
    thisMonth: 'මේ මාසය',
    lastMonth: 'පසුගිය මාසය',
    last30Days: 'පසුගිය දින 30',
    last3Months: 'පසුගිය මාස 3',
    customRange: 'අභිරුචි පරාසය',

    // Filters
    courierAccount: 'කුරියර් ගිණුම',
    allCouriers: 'සියලු කුරියර්',

    // Summary Cards
    totalDelivered: 'එකතුව බෙදාහැරීම්',
    totalReturned: 'එකතුව ආපසු ලැබීම්',
    inProcess: 'ක්‍රියාවේ පවතින',
    in_process: 'ක්‍රියාවේ පවතින',
    grandTotal: 'මුළු එකතුව',
    deliveryRate: 'බෙදාහැරීමේ අනුපාතය',
    returnRate: 'ආපසු ලැබීමේ අනුපාතය',

    // Chart
    showByCount: 'ගණන අනුව පෙන්වන්න',
    showByValue: 'අගය අනුව පෙන්වන්න',
    delivered: 'බෙදාහැරිය',
    returned: 'ආපසු ලැබුණි',

    // Table
    orderDetails: 'ඇණවුම් විස්තර',
    all: 'සියල්ල',
    dispatchedDate: 'බෙදාහැරූ දිනය',
    customerName: 'පාරිභෝගික නම',
    location: 'ස්ථානය',
    shippingZone: 'නැව්ගත ප්‍රදේශය',
    trackingNumber: 'අනුවර්තන අංකය',
    amount: 'මුදල',
    codAmount: 'COD මුදල',
    deliveryStatus: 'බෙදාහැරීමේ තත්ත්වය',
    searchOrders: 'ඇණවුම් අංකය, අනුවර්තන අංකය, හෝ පාරිභෝගික නම අනුව සොයන්න',
    orders: 'ඇණවුම්',

    // Empty States
    noDataYet: 'දත්ත නොමැත',
    selectFilters: 'කුරියර් කාර්ය සාධන දත්ත බැලීමට "පෙරහන් යොදන්න" ක්ලික් කරන්න',
  },

  // NOTE: placeholder translation — needs native-speaker review before release
  messageCenterSummary: {
    title: 'පණිවිඩ මධ්‍යස්ථාන සාරාංශය',
    subtitle: 'පණිවිඩ මධ්‍යස්ථාන මුරයේ කාර්ය සාධනය සහ තහවුරු කළ ඇණවුම් මිනුම් නිරීක්ෂණය කරන්න',
    kpiSectionTitle: 'ප්‍රධාන මිනුම්',
    kpiSectionTooltip: 'තෝරාගත් දින පරාසය සඳහා සාරාංශ මිනුම්',
    createdOrders: 'සාදන ලද ඇණවුම්',
    createdOrdersTooltip: 'තෝරාගත් කාල සීමාව තුළ පණිවිඩ මධ්‍යස්ථාන කණ්ඩායම විසින් සාදන ලද මුළු ඇණවුම්.',
    convertOrders: 'තහවුරු කළ ඇණවුම්',
    convertOrdersTooltip: 'තවමත් පොරොත්තුවෙන්, තහනම් කර ඇති, හෝ තහවුරු නොකළ ඇණවුම් හැර, කුරියරයට යවන ලද ඇණවුම් — වලංගු සැකසුම් අදියරක්.',
    deliveredOrders: 'බෙදාහරින ලද ඇණවුම්',
    deliveredOrdersTooltip: 'බෙදාහරින ලද බව තහවුරු කළ ඇණවුම් — අභ්‍යන්තරව සම්පූර්ණයෙන් වසා බෙදාහරින ලද, හෝ කුරියර් විසින් බෙදාහරින ලද බව සලකුණු කළ.',
    settledOrders: 'පියවන ලද ඇණවුම්',
    settledOrdersTooltip: 'පියවීමේ ක්‍රියාවලිය සම්පූර්ණ කළ බෙදාහරින ලද ඇණවුම්.',
    achievedVsTarget: 'ජයග්‍රහණය එදිරිව ඉලක්කය',
    achievedVsTargetTooltip: 'මුරයේ ඉලක්කයට එරෙහිව, කුරියරයට යවන ලද ඇණවුම්වලින් ලබාගත් විකුණුම් අගය.',
    totalCommission: 'මුළු කොමිස්',
    totalCommissionTooltip: 'පණිවිඩ මධ්‍යස්ථාන කණ්ඩායම විසින් උපයන ලද මුළු කොමිස්.',
    leader: 'නායක',
    createdProducts: 'සාදන ලද නිෂ්පාදන',
    createdValue: 'සාදන ලද අගය',
    totalOrders: 'මුළු ඇණවුම්',
    totalProducts: 'මුළු නිෂ්පාදන',
    totalValue: 'මුළු අගය',
    targetValue: 'ඉලක්ක අගය',
    commission: 'කොමිස්',
    todayShiftTitle: 'අද දිනයේ ජයග්‍රහණය — {{shiftTypeName}}',
    todayShiftTooltip: 'සාදන ලද ඇණවුම්, මුළු නිෂ්පාදන, ඇණවුම් අගය, සහ ඉලක්ක සාක්ෂාත් කිරීමේ ප්‍රතිශතය ඇතුළුව තෝරාගත් දින පරාසය තුළ මෙම මුර වර්ගයේ කාර්ය සාධන සාරාංශය.',
    rangeShiftTitle: 'ජයග්‍රහණය — {{shiftTypeName}}',
    last7DaysTitle: 'පසුගිය දින 7 ජයග්‍රහණය එදිරිව ඉලක්කය — {{shiftTypeName}}',
    last7DaysTooltip: 'පසුගිය දින 7 සඳහා තීරණය කළ ඉලක්කයට එරෙහිව ලබාගත් විකුණුම් අගයන්.',
    noShiftTypesFound: 'මෙම ව්‍යාපාරය සඳහා තවම මුර වර්ග වින්‍යාස කර නොමැත',
    noDataYet: 'දත්ත නොමැත',
    selectFiltersPrompt: 'පණිවිඩ මධ්‍යස්ථාන සාරාංශ දත්ත බැලීමට ඔබේ පෙරහන් තෝරා "පෙරහන් යොදන්න" ක්ලික් කරන්න',
    failedToLoad: 'පණිවිඩ මධ්‍යස්ථාන සාරාංශ දත්ත පූරණය කිරීමට අසමත් විය',
  },

  // NOTE: placeholder translation — needs native-speaker review before release
  callCenterSummary: {
    title: 'ඇමතුම් මධ්‍යස්ථාන සාරාංශය',
    subtitle: 'ඇමතුම් මධ්‍යස්ථාන KPI, නියෝජිත කාර්ය සාධනය සහ හරස්-විකුණුම් ප්‍රතිඵල නිරීක්ෂණය කරන්න',
    kpiSectionTitle: 'ප්‍රධාන මිනුම්',
    kpiSectionTooltip: 'තෝරාගත් දින පරාසය සඳහා සාරාංශ මිනුම්',
    createdOrderItems: 'සාදන ලද ඇණවුම් අයිතම',
    createdOrderItemsTooltip: 'සාදන ලද ඇණවුම්වල ඇති නිෂ්පාදන මුළු ගණන.',
    validOrderItems: 'වලංගු ඇණවුම් අයිතම',
    validOrderItemsTooltip: 'වලංගු/තහවුරු කළ ඇණවුම්වල ඇති නිෂ්පාදන මුළු ගණන.',
    deliveredOrderItems: 'බෙදාහරින ලද ඇණවුම් අයිතම',
    deliveredOrderItemsTooltip: 'බෙදාහරින ලද බව තහවුරු කළ ඇණවුම්වල හරස්-විකුණන ලද අයිතම — අභ්‍යන්තරව සම්පූර්ණයෙන් වසා බෙදාහරින ලද, හෝ කුරියර් විසින් බෙදාහරින ලද බව සලකුණු කළ.',
    settledOrderItems: 'පියවන ලද ඇණවුම් අයිතම',
    settledOrderItemsTooltip: 'පියවන ලද ඇණවුම්වල ඇති නිෂ්පාදන මුළු ගණන.',
    inCourier: 'කුරියරයේ',
    inCourierTooltip: 'කුරියර් හවුල්කරුවන් සමඟ ප්‍රවාහනයේ පවතින නිෂ්පාදන.',
    returns: 'ආපසු භාර',
    returnsTooltip: 'ආපසු භාර ගත් හෝ ආපසු භාර ගැනීමට ඉතිරි නිෂ්පාදන.',
    otherOrderItems: 'වෙනත් ඇණවුම් අයිතම',
    otherOrderItemsTooltip: 'වෙනත් ඇණවුම් තත්ත්වයන්හි ඇති නිෂ්පාදන (අවලංගු, තහනම් ආදිය).',
    discount: 'වට්ටම',
    discountTooltip: 'ඇණවුම්වලට යොදන ලද මුළු වට්ටම් මුදල.',
    products: 'නිෂ්පාදන',
    orderValue: 'ඇණවුම් අගය',
    targetValue: 'ඉලක්ක අගය',
    commission: 'කොමිස්',
    product: 'නිෂ්පාදනය',
    count: 'ගණන',
    revenue: 'ආදායම (LKR)',
    name: 'නම',
    remaining: 'ඉතිරි',
    targetAchieved: 'ඉලක්කය සපුරා ඇත',
    rank: 'ශ්‍රේණිය',
    confirmCount: 'තහවුරු ගණන',
    sales: 'විකුණුම්',
    todayAchievement: 'ජයග්‍රහණය (තෝරාගත් කාලය)',
    todayAchievementTooltip: 'තෝරාගත් කාලය තුළ තහවුරු කළ ඇණවුම් සඳහා හරස්-විකුණුම් කාර්ය සාධනය — නිෂ්පාදන, ඇණවුම් අගය, ඉලක්කය, වට්ටම, සහ කොමිස්.',
    periodLabel: 'කාලය',
    last7DaysTitle: 'පසුගිය දින 7 ජයග්‍රහණය එදිරිව ඉලක්කය',
    last7DaysTooltip: 'පසුගිය දින 7 සඳහා ඇමතුම් මධ්‍යස්ථානයේ ලබාගත් විකුණුම් අගය එදිරිව ඉලක්ක කාර්ය සාධනය.',
    crossSellingTitle: 'වැඩිම හරස්-විකුණුම් නිෂ්පාදන',
    crossSellingTooltip: 'තෝරාගත් කාල සීමාව සඳහා ඇණවුම් ගණන අනුව වඩාත්ම අලෙවි වූ නිෂ්පාදන 10.',
    targetPerAgentTitle: 'නියෝජිතයන් සඳහා ඉලක්කය',
    targetPerAgentTooltip: 'තෝරාගත් කාල සීමාව සඳහා එක් එක් නියෝජිතයාගේ හරස්-විකුණුම් ඉලක්කය එදිරිව ලබාගත් අගය.',
    agentPerformanceTitle: 'නියෝජිත කාර්ය සාධනය',
    agentPerformanceTooltip: 'තෝරාගත් කාල සීමාව සඳහා මුළු තහවුරු කළ ඇණවුම් විකුණුම් අගය අනුව සියලුම නියෝජිතයන්ගේ ශ්‍රේණිගත කිරීම (හරස්-විකුණුම් සඳහා පමණක් නොව ඕනෑම ඇණවුමක්).',
    noDataYet: 'දත්ත නොමැත',
    selectFiltersPrompt: 'ඇමතුම් මධ්‍යස්ථාන සාරාංශ දත්ත බැලීමට ඔබේ පෙරහන් තෝරා "පෙරහන් යොදන්න" ක්ලික් කරන්න',
    failedToLoad: 'ඇමතුම් මධ්‍යස්ථාන සාරාංශ දත්ත පූරණය කිරීමට අසමත් විය',
  },
  // TODO(si/ta): English placeholders — translate
  productWiseSales: {
    title: 'Product Wise Sales',
    description: 'Units, amounts and discounts per product for dispatched orders',
    shops: 'Shops',
    allShops: 'All shops',
    dateRange: 'Dispatched Date',
    searchPlaceholder: 'Search products...',
    excel: 'Excel',
    pdf: 'PDF',
    noData: 'No product sales found for the selected filters',
    failedToLoad: 'Failed to load product wise sales',
    exportFailed: 'Failed to export report',
    cards: {
      orderCount: 'Total Order Count',
      orderAmount: 'Total Order Amount',
      orderDiscount: 'Total Order Discount',
      productCount: 'Total Product Count',
      productAmount: 'Total Product Amount',
      productDiscount: 'Total Product Discount',
    },
    columns: {
      productName: 'Title',
      itemCount: 'Item Count',
      amount: 'Amount',
      contribution: 'Contribution (%)',
      discount: 'Discount',
      amountAfterDiscount: 'Amount After Discount',
      amountPerItem: 'Amount per Item',
      discountPerItem: 'Discount per Item',
      discountPctPerItem: 'Discount % per Item',
    },
  },
  // TODO(si/ta): English placeholders — translate
  productWiseReturns: {
    title: 'Product Wise Returns',
    description: 'Units, amounts and discounts per product for returned orders',
    shops: 'Shops',
    allShops: 'All shops',
    dateRange: 'Return Date',
    allReturnSources: 'All return batches & notes',
    searchReturnSources: 'Search return batches & notes...',
    returnBatch: 'Return Batch',
    returnNote: 'Return Note',
    searchPlaceholder: 'Search products...',
    excel: 'Excel',
    pdf: 'PDF',
    noData: 'No product returns found for the selected filters',
    failedToLoad: 'Failed to load product wise returns',
    exportFailed: 'Failed to export report',
    cards: {
      orderCount: 'Total Return Order Count',
      orderAmount: 'Total Return Order Amount',
      orderDiscount: 'Total Return Order Discount',
      productCount: 'Total Returned Product Count',
      productAmount: 'Total Returned Product Amount',
      productDiscount: 'Total Returned Product Discount',
    },
    columns: {
      productName: 'Title',
      itemCount: 'Item Count',
      amount: 'Amount',
      contribution: 'Contribution (%)',
      discount: 'Discount',
      amountAfterDiscount: 'Amount After Discount',
      amountPerItem: 'Amount per Item',
      discountPerItem: 'Discount per Item',
      discountPctPerItem: 'Discount % per Item',
    },
  },
  ccPerformanceUsers: {
    selectUsers: "පරිශීලකයන් තෝරන්න",
    title: "වාර්තාවේ පෙන්වන පරිශීලකයන්",
    hint: "ඇතුළත් කළ යුතු පරිශීලකයන් තෝරන්න. කිසිවක් තෝරා නොමැති නම්, සියලුම පරිශීලකයන් පෙන්වයි.",
    selectAll: "සියල්ල තෝරන්න",
    clearAll: "සියල්ල ඉවත් කරන්න",
    saved: "පරිශීලක තේරීම සුරකින ලදී",
    saveFailed: "පරිශීලක තේරීම සුරැකීමට අසමත් විය",
    loadFailed: "පරිශීලකයන් පූරණය කිරීමට අසමත් විය",
    searchUsers: "නමෙන් පරිශීලකයන් සොයන්න",
    noUsersFound: "පරිශීලකයන් හමු නොවීය",
  },
};
